/**
 * Polling interval configuration for integration status updates
 */
export enum PollingInterval {
  /**
   * Long polling interval (30 seconds)
   * Used during normal operation when no active sync is happening
   */
  LONG = 'LONG',

  /**
   * Short polling interval (1 second)
   * Used during active sync operations to provide real-time updates
   */
  SHORT = 'SHORT',
}
